import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "An experiment to merge React and Vue",
  "description": "",
  "published": "2019-02-20T00:00:00.000Z",
  "redirect_from": ["/blog/an-experiment-to-merge-react-and-vue/swizec/8952"],
  "categories": "Front End, Technical",
  "hero": "./img/media-Dz1Ot1tV4AAdfHI.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I tried an experiment. It failed miserably but it wasn't my fault.`}</p>
    <lite-youtube {...{
      "videoid": "S4sHVhFdtHs",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`The goal was to build a `}<inlineCode parentName="p">{`useVue`}</inlineCode>{` React hook that would let us render Vue components inside React. Why would anyone do this? Good question.`}</p>
    <p>{`Here's what it looks like`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "778px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/16d8ac4f85aaa852ded8576f2fd8a576/20982/media-Dz1Ot1tV4AAdfHI.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "95.06726457399104%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'379\\'%20viewBox=\\'0%200%20400%20379\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M35%2052c-1%201-2%2024-2%20137%200%20133%200%20136%202%20138l2%203h326l2-3c2-2%202-5%202-138%200-113-1-136-2-137-1-2-14-2-165-2S36%2050%2035%2052m37%2015c-3%202-3%206-1%209%202%202%208%201%2010-2%203-6-5-12-9-7m21%200c-3%202-4%205-1%208%201%203%206%203%208%200%205-5-2-12-7-8\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/16d8ac4f85aaa852ded8576f2fd8a576/ca0a1/media-Dz1Ot1tV4AAdfHI.webp 223w", "/static/16d8ac4f85aaa852ded8576f2fd8a576/75680/media-Dz1Ot1tV4AAdfHI.webp 445w", "/static/16d8ac4f85aaa852ded8576f2fd8a576/10884/media-Dz1Ot1tV4AAdfHI.webp 778w"],
              "sizes": "(max-width: 778px) 100vw, 778px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/16d8ac4f85aaa852ded8576f2fd8a576/e92b6/media-Dz1Ot1tV4AAdfHI.png 223w", "/static/16d8ac4f85aaa852ded8576f2fd8a576/e66bf/media-Dz1Ot1tV4AAdfHI.png 445w", "/static/16d8ac4f85aaa852ded8576f2fd8a576/20982/media-Dz1Ot1tV4AAdfHI.png 778w"],
              "sizes": "(max-width: 778px) 100vw, 778px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/16d8ac4f85aaa852ded8576f2fd8a576/20982/media-Dz1Ot1tV4AAdfHI.png",
              "alt": "media Dz1Ot1tV4AAdfHI",
              "title": "media Dz1Ot1tV4AAdfHI",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`It's based on my `}<a parentName="p" {...{
        "href": "https://d3blackbox.com/"
      }}>{`D3blackbox approach`}</a>{` to wrapping random D3 examples in React components. Quick for meeting deadlines, great for small components you don't wanna build yourself.`}</p>
    <p>{`Same thing here:`}</p>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`useRef`}</inlineCode>{` creates a React ref`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`useEffect`}</inlineCode>{` runs on component mount and does Vue stuff`}</li>
    </ol>
    <p>{`You use `}<inlineCode parentName="p">{`useVue`}</inlineCode>{` by passing in a Vue component and receiving a React ref. Then you render an anchor element. `}<inlineCode parentName="p">{`useVue`}</inlineCode>{` places your Vue component in that element.`}</p>
    <p>{`Like this`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d2a3659b11a252524ed38fce23a20f98/84ae3/media-Dz3ViSsUwAAgGmQ.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.91928251121077%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'265\\'%20viewBox=\\'0%200%20400%20265\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2037v191c1%203%20351%203%20352%200V37c-1-3-351-3-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d2a3659b11a252524ed38fce23a20f98/ca0a1/media-Dz3ViSsUwAAgGmQ.webp 223w", "/static/d2a3659b11a252524ed38fce23a20f98/75680/media-Dz3ViSsUwAAgGmQ.webp 445w", "/static/d2a3659b11a252524ed38fce23a20f98/8d1ba/media-Dz3ViSsUwAAgGmQ.webp 890w", "/static/d2a3659b11a252524ed38fce23a20f98/36c36/media-Dz3ViSsUwAAgGmQ.webp 1116w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d2a3659b11a252524ed38fce23a20f98/853b2/media-Dz3ViSsUwAAgGmQ.jpg 223w", "/static/d2a3659b11a252524ed38fce23a20f98/0a4fe/media-Dz3ViSsUwAAgGmQ.jpg 445w", "/static/d2a3659b11a252524ed38fce23a20f98/7f80b/media-Dz3ViSsUwAAgGmQ.jpg 890w", "/static/d2a3659b11a252524ed38fce23a20f98/84ae3/media-Dz3ViSsUwAAgGmQ.jpg 1116w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d2a3659b11a252524ed38fce23a20f98/7f80b/media-Dz3ViSsUwAAgGmQ.jpg",
              "alt": "media Dz3ViSsUwAAgGmQ",
              "title": "media Dz3ViSsUwAAgGmQ",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Great, right?`}</p>
    <p>{`Except this is where it all falls apart. I can't figure out how to set up `}<a parentName="p" {...{
        "href": "https://codesandbox.io/s/l9r49oqo57"
      }}>{`my Codesandbox`}</a>{` to support both Vue and React at the same time.`}</p>
    <p>{`Start with a Vue project and JSX doesn't work. Building your React components with `}<inlineCode parentName="p">{`React.createElement`}</inlineCode>{` is no fun.`}</p>
    <p>{`Start with a React project and you can import `}<inlineCode parentName="p">{`.vue`}</inlineCode>{` files but they import as a string. No JavaScript, no `}<inlineCode parentName="p">{`<template>`}</inlineCode>{` tags, no nothing.`}</p>
    <p>{`Just a little error saying Swizec is dumb.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/cf29b0500b8d5f090c2110dc3873c814/8bb81/WHwONqY.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "29.14798206278027%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'116\\'%20viewBox=\\'0%200%20400%20116\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2058v58h401V0H0v58M14%208c-4%203-2%205%205%205%205%200%206-1%206-2h1c0%202%2012%203%2013%201h1l2%201%202-2c0-2-2-3-4-2-1%201-1%201-1-1s0-2-1-1l-3%201-2%201h-1c-3-1-12-1-14%201l-3%201c-2-1%200-3%202-2V8c-2-2-1-2-3%200m64%202c0%202%200%203%201%202s4-2%204%200l1%201%201-2h1c1%202%2011%202%2012%201h1l2%201v-2l2%201c0%202%202%201%202-1l1%201h1l1-2%201%202c1%201%201%200%201-1%200-2-1-3-5-3l-6%201h-1l-1-2-1%202h-2c-2-2-3-2-3%200h-1l-4-1h-4c-1-3-4-1-4%202m121%2027l-1%204c-1%200-2%200-1-1l-1-2c0-1-1-1-1%201-1%201-1%201-1-1%201-2%200-3-1-1h-2c-1-2-2-1-1%201%200%202%200%202-1%201%200-2-1-2-1-1v2l-1%201-2-3-1-2v3c0%201%200%202-2%202l-1-3v-1c-1%202-2%202-2%201-1-1-1%200-1%201%201%202%201%202-2%201l-1-1%202-1c-1-2-3-2-4%201-1%202-1%202-1-1s0-3-2-2l-5%202c-2%201-2%201%200%201%204%200%204%202%201%202-4%200-6-1-5-2v-2c-1-2-3%200-3%202v2l-1-2c0-2%200-2-1%200h-1l-1-2-1%202v2c-1%200-2-1-1-2%200-2%200-2-1-1h-1l-1-1v2c1%202%201%202-1%202-3%200-3%200-2-2l1-3-2%202-2%203-1-1v-3l-1-1c-1%200-2%202-1%203%201%200%201%201-1%202-1%201%204%201%2033%201h35l-1-2-1-3h-2v3c-2%201-3%200-3-2l-1-3v2M72%2036v2l-1%203c-1%201%203%201%2030%201%2029%200%2037-1%2030-2v-1l2-1c-1-2-3-2-4%201-1%202-1%202-1%200%200-3%200-3-1-1%200%202-2%203-2%200-1-1-1-1-1%201l-1%202v-2c0-1%200-2-1-1%200%201-1%201-2-1-1-1-1-1-1%201%201%203%201%203-1%203s-2%200-1-3l1-3c-1%200-2%201-2%203-2%203-2%203-2%201%200-3-2-4-5-2h-1l-1%202c-1%201-1%201-1-1v-2c-1%200-2%203-1%204h-3v-2l1-2c-1-1-3%201-3%203l-1%202-2-1h-1c-1%201-5%201-5-1h3l-2-3c-2-1-2-1-2%202s0%203-1%201l-1-1c0%203-2%202-2%200s0-2-1%201c-1%202-1%202-1%200l-2-3c-2-1-2-1-2%202s0%203-2%202v-3c1%200%201-1-1-1-1-1-1%200-1%202%201%204-2%204-3%200l-1-2m143%2035l-2%201-1%203v2l-2-3-1-2v1l-1%203c-2%201-2%201-2-2v-2l-1%202c-1%202-1%202-1%200l-1-2-1%203v3h48v-3c0-2%200-3-2-3l-1%203-1%202-2-5-1-2v4l-1%203-2-2c0-2%200-2-4-2-3%200-5-1-5-2s-1-1-3%201c-1%201-2%202-1%203%200%202%200%202-2%202s-2%200%200-3v-3l-2%203c-1%202-2%203-3%202-2%200-3-2-1-2l2-1-2-1c-1%200-2%201-2%203s0%202-1-1l-1-3m66%200l-1%203c0%203-1%204-2%202h-2c-1%201-3%200-3-3l-1-2-1%203v3l-1-2c-1-3-4-4-4-1%200%202%200%203-2%202l-2-1%201-1h1c0-1-2-2-5-2l-5%201h-1c-1-1-2%200-2%202%201%204%201%204%203%200l2-1-1%203c-1%201%204%201%2021%201%2021%200%2023%200%2023-2l-1-4-1-2-1%204v3l-1-2c-1-4-5-4-5-1%200%202%200%203-1%202l-1-2c1-2%200-3-2-3v4c1%201%201%202-1%202l-1-2c0-2-2-5-3-4m-136%203c-2%204-5%204-4%201v-2l-2%202c-1%202-1%202-2%201h-2c0%202-3%201-2%200l-1-2v-1l-1-1c-2%200-2%201-1%203v1c-2%201-2%200-2-2l-2-2c-2%200-2%201-2%203v3h19l19-1-1-1-1-2h1l1-1-2-1-1%203-1%202-1-3v-2l-1%202c-1%202-1%202-1%200s-3-3-4-1h-1l-1-1v3c1%202%201%202-2%202-2%200-2%200-1-3l1-3c-1%200-2%201-2%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/cf29b0500b8d5f090c2110dc3873c814/ca0a1/WHwONqY.webp 223w", "/static/cf29b0500b8d5f090c2110dc3873c814/75680/WHwONqY.webp 445w", "/static/cf29b0500b8d5f090c2110dc3873c814/8d1ba/WHwONqY.webp 890w", "/static/cf29b0500b8d5f090c2110dc3873c814/3838e/WHwONqY.webp 1335w", "/static/cf29b0500b8d5f090c2110dc3873c814/e2173/WHwONqY.webp 1602w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/cf29b0500b8d5f090c2110dc3873c814/e92b6/WHwONqY.png 223w", "/static/cf29b0500b8d5f090c2110dc3873c814/e66bf/WHwONqY.png 445w", "/static/cf29b0500b8d5f090c2110dc3873c814/4ef49/WHwONqY.png 890w", "/static/cf29b0500b8d5f090c2110dc3873c814/4e814/WHwONqY.png 1335w", "/static/cf29b0500b8d5f090c2110dc3873c814/8bb81/WHwONqY.png 1602w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/cf29b0500b8d5f090c2110dc3873c814/4ef49/WHwONqY.png",
              "alt": "WHwONqY",
              "title": "WHwONqY",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Doesn't even have the decency to show an error. Dig deep and you see it's something like `}<inlineCode parentName="p">{`This large 30 line string is not a DOM element`}</inlineCode>{`. No shit it isn't.`}</p>
    <p>{`I know it's possible to have React and Vue in the same project. We've done it at dayjob.exe for ... reasons.`}</p>
    <p>{`Would like to avoid building my own Webpack config from scratch just to prove this experiment works. 😅 You'd need to basically say `}<em parentName="p">{`"Ok, use Vue for .vue files, React for .js files"`}</em></p>
    <p>{`Have you tried this before? Got any tips? Hit reply or answer this tweet`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`But who can I ask about configuring a Codesandbox for both Vue and React?`}<a parentName="p" {...{
          "href": "https://twitter.com/CompuIves"
        }}>{`@CompuIves`}</a>{` anyone tried this before? Is it possible?`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1098269284378103808"
      }}>{`February 20, 2019`}</a></blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      